import _ from 'lodash';
import FuseSettingsConfig from 'fuse-configs/fuseSettingsConfig';

const defaultSettings = {
    layout          : {
        style : 'layout1',
        config: {
            scroll : 'content',
            navbar : {
                display : true,
                folded  : false,
                position: 'left'
            },
            toolbar: {
                display : true,
                style   : 'fixed',
                position: 'below'
            },
            footer : {
                display : true,
                style   : 'fixed',
                position: 'below'
            },
            mode   : 'fullwidth'
        }
    },
    customScrollbars: true,
    theme           : {
        main   : 'Default',
        navbar : 'mainThemeDark',
        toolbar: 'mainThemeLight',
        footer : 'mainThemeDark'
    }
};

const FuseDefaultSettings = _.merge({}, defaultSettings, FuseSettingsConfig);

export default FuseDefaultSettings;



// WEBPACK FOOTER //
// ./src/@fuse/FuseDefaultSettings.js